import ky from 'ky';

import {
  isApiCodeKnown,
  API_ERRORS,
  isServerStatusKnown,
  SERVER_ERRORS,
  DEFAULT_ERROR,
  AppError,
} from './errors';

import type {ApiErrorEntry} from './errors';

import type {
  HTTPError,
  KyInstance,
  Options,
  BeforeRequestHook,
  BeforeErrorState,
} from 'ky';

export const createBaseApi = (
  url: string,
  attachToken: BeforeRequestHook,
  options: Options = {}
): KyInstance => {
  return ky.create({
    prefix: url,
    retry: 0,
    timeout: 30000,
    ...options,
    hooks: {
      ...options?.hooks,
      beforeError: [
        handleBeforeServerError,
        ({error: e}: BeforeErrorState): Error => {
          const data = (e as HTTPError).data as
            | {error?: {code?: number}}
            | undefined;
          const code = data?.error?.code;
          if (code !== undefined && isApiCodeKnown(code)) {
            const {message, kind, title} = API_ERRORS[code] as ApiErrorEntry;
            return new AppError(message, kind, title, code);
          }
          return e;
        },
        ...(options?.hooks?.beforeError || []),
      ],
      beforeRequest: [attachToken, ...(options?.hooks?.beforeRequest || [])],
    },
  });
};

export const createBlobApi = (
  url: string,
  attachToken: BeforeRequestHook
): KyInstance => {
  return ky.create({
    prefix: url,
    timeout: 30000,
    retry: {
      limit: 2,
      statusCodes: [401, 403],
    },
    hooks: {
      beforeError: [handleBeforeServerError],
      beforeRequest: [attachToken],
    },
  });
};

function handleBeforeServerError({error}: BeforeErrorState): Error {
  if (!(error instanceof Error) || !('response' in error)) return error;
  const httpError = error as HTTPError;
  if (httpError.response && isServerStatusKnown(httpError.response.status)) {
    httpError.message = SERVER_ERRORS[httpError.response.status];
  } else {
    httpError.message = DEFAULT_ERROR;
  }
  return httpError;
}
